import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  constructor(private location: Location) {}

  isLocalhost(): boolean {
    const hostname = window.location.hostname;
    return hostname === 'localhost' ||
           hostname === '127.0.0.1' ||
           hostname === '0.0.0.0' ||
           hostname.startsWith('192.168.') ||
           hostname.startsWith('10.') ||
           hostname.includes('localhost');
  }

  isDevelopment(): boolean {
    return this.isLocalhost() || window.location.href.includes('ionic://');
  }

  getBaseUrl(): string {
    return window.location.origin;
  }

  getCurrentEnvironment(): 'localhost' | 'development' | 'production' {
    if (this.isLocalhost()) {
      return 'localhost';
    }
    // Add your development domain check here
    if (window.location.hostname.includes('dev.') ||
        window.location.hostname.includes('staging.') ||
      window.location.hostname.includes('mig') ||
      window.location.hostname.includes('beta')) {
      return 'development';
    }
    return 'production';
  }
}
